import * as React from "react"
import { useRecoilValue } from "recoil"
import {
  watchPartyHostIdSelector,
  watchPartyScreenLinkSelector,
  watchPartyScreenSelector
} from "../../recoil/atoms/watchPartyScreen"
import { localUserIdAtom } from "../../recoil/atoms/users"
import { useMeetingClientRef } from "../useMeetingClient"

export const useWatchParty = () => {
  const watchPartyHostId = useRecoilValue(watchPartyHostIdSelector)
  const isWatchParty = useRecoilValue(watchPartyScreenSelector)
  const _localUserId = useRecoilValue(localUserIdAtom)
  const wpSrc = useRecoilValue(watchPartyScreenLinkSelector)
  const watchPartyType = React.useMemo<string>(() => {
    if (wpSrc !== "") {
      if (wpSrc.endsWith(".mp3")) {
        return "audio"
      } else {
        return "video"
      }
    } else {
      return "empty"
    }
  }, [wpSrc])

  const isAudioWatchParty = React.useMemo(
    () => (wpSrc && wpSrc.endsWith(".mp3") ? true : false),
    [wpSrc]
  )

  const isModPresentVideo = React.useMemo(
    () => watchPartyHostId === "modNotPresentVideo",
    [watchPartyHostId]
  )

  const isModPresentImage = React.useMemo(
    () =>
      watchPartyHostId === "modNotPresentImage" ||
      watchPartyHostId === "modNotPresentOverlay",
    [watchPartyHostId]
  )

  const isHost = React.useMemo(
    () => watchPartyHostId === _localUserId,
    [_localUserId, watchPartyHostId]
  )

  return {
    watchPartyHostId,
    isWatchParty,
    watchPartyType,
    wpSrc,
    isAudioWatchParty,
    isModPresentVideo,
    isModPresentImage,
    isHost
  }
}


export const useWatchPartyController = () => {
  const localUserId = useRecoilValue(localUserIdAtom)
  const meetingClientRef = useMeetingClientRef()

  const startWatchParty = React.useCallback(
    (src: string) => {
      const meetingClient = meetingClientRef.current
      meetingClient?.rtc.toggleWatchParty(src)
      meetingClient?.sendStartingWatchParty(localUserId)
    },
    [localUserId]
  )

  const stopWatchParty = React.useCallback(() => {
    const meetingClient = meetingClientRef.current
    meetingClient?.rtc.stopWatchParty()
    meetingClient?.sendStoppingWatchParty(localUserId)
  }, [localUserId])

  return {
    startWatchParty,
    stopWatchParty
  }
}
